import script from "./Slogan.vue?vue&type=script&setup=true&lang=js"
export * from "./Slogan.vue?vue&type=script&setup=true&lang=js"

import "./Slogan.vue?vue&type=style&index=0&id=7d6e689e&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d6e689e"]])

export default __exports__